import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../services/service.index';
import { RolesService } from '../services/roles/roles.service';
import Swal2 from 'sweetalert2';

@Component({
  selector: 'app-loginunita',
  templateUrl: './loginunita.component.html',
  styleUrls: ['./loginunita.component.css']
})
export class LoginUnitaComponent implements OnInit {
  focus = false;
  focus1 = false;
  recuperacont = false;
  showPassword = false;

  constructor(
    public router: Router,
    private usuarioservice: UsuarioService,
    private rolesService: RolesService
  ) {}

  ngOnInit() {
    if (localStorage.getItem('quiensoy') === 'unita' && localStorage.getItem('tkn')) {
      this.rolesService.getRol(localStorage.getItem('rid')).subscribe(resp => {
        if (resp[0].name === 'SuperAdmin' || resp[0].name === 'Analista') {
          this.router.navigate(['/panelcontrol/aprobarCreditos']);
        } else if (resp[0].name === 'Vendedor') {
          this.router.navigate(['/panelcontrol/revisarCotizaciones']);
        } else if (resp[0].name === 'Médico') {
          this.usuarioservice.getCustomerxidu(localStorage.getItem('uid')).subscribe(r => {
            if (r.length > 0) {
              this.router.navigate([`/maincliente/solicitudcredito/${localStorage.getItem('uid')}`]);
            } else {
              this.router.navigate([`/registroemp`]);
            }
          });
        } else {
          this.router.navigate(['/panelcontrol/aprobarCreditos/mesaControl']);
        }
      }, err => {
        console.log('error', err);
      });
    }
  }

  login() {
    Swal2.showLoading();
    const correo = (document.getElementById('correo') as HTMLInputElement).value;
    const pass = (document.getElementById('password') as HTMLInputElement).value;
    this.usuarioservice.login(correo, pass).subscribe(resp => {
      if (resp.data.attributes.status !== 'AC') {
        Swal2.fire('El usuario no se encuentra activo', '', 'error');
      } else {
        localStorage.setItem('uid', resp.data.attributes.id);
        localStorage.setItem('tkn', resp.data.token);
        localStorage.setItem('emailuser', resp.data.attributes.email);
        localStorage.setItem('nombreuser', resp.data.attributes.name);
        localStorage.setItem('expiratoken', resp.data.expires_at);
        localStorage.setItem('quiensoy', 'unita');
        if (resp.data.attributes.role_id != null) {
          localStorage.setItem('rid', resp.data.attributes.role_id);
          window.location.reload();
        } else {
          Swal2.fire('Datos incompletos', 'Comuníquese con el administrador', 'info');
        }
      }
    }, (err) => {
      console.clear();
      console.log(err);
      Swal2.fire('Error al acceder', 'Revise su información', 'error');
    });
  }

  recuperarcont() {
    this.recuperacont = !this.recuperacont;
  }

  enviacrecuperacion() {
    const email = (document.getElementById('emailrec') as HTMLInputElement).value;
    this.usuarioservice.getResetPaswword(email).subscribe(resp => {
      this.recuperacont = !this.recuperacont;
      Swal2.fire('El correo de recuperación de contraseña fue enviado a:', email, 'success');
    }, (err) => {
      console.log(err);
      Swal2.fire('Error', err.error.errors[0], 'error');
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    const x = (document.getElementById('password') as HTMLInputElement);
    x.type = this.showPassword ? 'text' : 'password';
  }
}
